import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CourseContext from './CourseContext';

const CourseProvider = (props) => {
  const { children } = props;

  const [course, setCourse] = useState();

  return (
    <CourseContext.Provider value={{ course, setCourse }}>
      {children}
    </CourseContext.Provider>
  );
};

CourseProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CourseProvider;
